import {Route, Routes} from 'react-router-dom';

import TemplateInvoice from './mau-hoa-don';
import Notification from './thong-bao';
import Help from './xu-ly-loi';

export default function Admin() {

  return (
    <Routes>
      <Route path="mau-hoa-don/*" element={<TemplateInvoice/>}/>
      <Route path="thong-bao/*" element={<Notification/>}/>
      <Route path="xu-ly-loi/*" element={<Help/>}/>
    </Routes>
  );
}
